import ErrorBoundaryFallback from '@/components/shared/ErrorBoundaryFallback';
import { FloatingChatBot } from '@/components/shared/FloatingChatBot';
import { LoadingPage } from '@/components/shared/Spinner';
import { Toaster } from '@/components/ui/toaster.tsx';
import { AuthProvider } from '@/context/auth.context.tsx';
import '@/index.css';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet, useLocation, useRouteContext } from '@tanstack/react-router';
import { Suspense, useEffect } from 'react';


interface RouteContext {
    queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouteContext>()({
    component: RootComponent
})

function RootComponent() {
    const { queryClient } = useRouteContext({ from: '__root__' });
    const location = useLocation();


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <QueryClientProvider client={queryClient}>
            <Suspense fallback={<LoadingPage />}>
                <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorBoundaryFallback error={error as Error} resetErrorBoundary={resetError} />}>
                    <AuthProvider>
                        <Outlet />
                        <Toaster />
                        <FloatingChatBot />
                    </AuthProvider>
                </Sentry.ErrorBoundary>
            </Suspense>
        </QueryClientProvider>
    );
}
